import React, {ReactElement} from 'react';
import icon from '@assets/images/medops/email.svg';

const EmailIcon = (props: any): ReactElement => {
  return <img src={icon} {...props} />;
};

export default EmailIcon;
